






















































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import TOCNode from '@/models/KnowledgeBase/TOCNode';
import KBContentListItem from '@/models/KnowledgeBase/KBContentListItem';

@Component({
  name: 'TOCNodeListEditor'
})
export default class TOCNodeListEditor extends Vue {
  @Prop({ required: true }) nodes!: TOCNode[];
  @Prop({ required: true }) sectionIndex!: number;
  @Prop({ required: true }) availableContent!: KBContentListItem[];
  @Prop({ required: true }) depth!: number;

  updateContentId(index: number, contentId: string) {
    this.nodes[index].contentId = contentId;
    this.$emit('change');
  }

  updateLabel(index: number, label: string) {
    this.nodes[index].label = label;
    this.$emit('change');
  }

  toggleFolder(index: number) {
    // Use Vue.set for reactivity
    this.$set(this.nodes[index], 'expanded', !this.nodes[index].expanded);
    this.$emit('change');
  }

  addArticle(folderIndex: number) {
    const folder = this.nodes[folderIndex];

    // Initialize items array if it doesn't exist
    if (!folder.items) {
      this.$set(folder, 'items', []);
    }

    const newNode = new TOCNode();
    newNode.type = 'article';
    newNode.contentId = '';
    newNode.order = folder.items.length;

    folder.items.push(newNode);
    this.$set(folder, 'expanded', true); // Auto-expand when adding
    this.$emit('change');
  }

  addFolder(folderIndex: number) {
    const folder = this.nodes[folderIndex];

    // Initialize items array if it doesn't exist
    if (!folder.items) {
      this.$set(folder, 'items', []);
    }

    const newNode = new TOCNode();
    newNode.type = 'folder';
    newNode.label = 'New Subfolder';
    newNode.expanded = false;
    newNode.items = [];
    newNode.order = folder.items.length;

    folder.items.push(newNode);
    this.$set(folder, 'expanded', true); // Auto-expand when adding
    this.$emit('change');
  }

  removeNode(index: number) {
    this.nodes.splice(index, 1);
    // Update order
    this.nodes.forEach((node, i) => {
      node.order = i;
    });
    this.$emit('change');
  }
}
